import { FC } from 'react'

import { DateTime, Info } from 'ui/components'
import { Col, Col2x, Row } from 'ui/themes/globalStyles'
import { CRBLicenses } from '~bank-crb-monitor/types'

import { CRBStatus } from '../../../CRBStatus/CRBStatus'

export const Details: FC<{ license: CRBLicenses }> = ({ license }) => {
  const {
    id,
    businesses,
    medRecClassification,
    licensingAuthorityName,
    locality,
    uniformTypeDescription,
    status,
    reportedTypeDescription,
    reportedStatus,
    statusDate,
    showPreviousStatus,
    statusTag,
    showConnectionStatusChangedAt,
    showStatusLastCheckedAt
  } = license

  return (
    <>
      <Row>
        <Col2x>
          <Info label="Businesses">{businesses}</Info>
        </Col2x>
      </Row>
      <Row>
        <Col>
          <Info label="CRBM ID">{id}</Info>
        </Col>
        <Col>
          <Info label="Med/Rec/Hemp">{medRecClassification}</Info>
        </Col>
      </Row>
      <Row>
        <Col2x>
          <Info label="Licensing Authority">{licensingAuthorityName}</Info>
        </Col2x>
      </Row>
      <Row>
        <Col2x>
          <Info label="Locality">{locality}</Info>
        </Col2x>
      </Row>
      <Row>
        <Col>
          <Info label="Uniform Type">{uniformTypeDescription}</Info>
        </Col>
        <Col>
          <Info label="Uniform Status">
            <CRBStatus icon={statusTag} status={status} />
          </Info>
        </Col>
      </Row>
      <Row>
        <Col>
          <Info label="Reported Type">{reportedTypeDescription}</Info>
        </Col>
        <Col>
          <Info label="Reported Status">{reportedStatus}</Info>
        </Col>
      </Row>
      <Row>
        <Col>
          <Info label="Status As Of">
            <DateTime date={statusDate} />
          </Info>
        </Col>
        <Col>
          <Info label="Previous Status">{showPreviousStatus}</Info>
        </Col>
      </Row>
      <Row>
        <Col>
          <Info label="Connected At">
            {showConnectionStatusChangedAt && <DateTime date={showConnectionStatusChangedAt} withTime />}
          </Info>
        </Col>
        <Col>
          <Info label="Last Check">
            {showStatusLastCheckedAt && <DateTime date={showStatusLastCheckedAt} withTime />}
          </Info>
        </Col>
      </Row>
    </>
  )
}
